import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { dataAlumno } from 'data/apiConection.js/dataAlumnos';
import { dataCuota } from 'data/apiConection.js/dataCuotas';
import { Card, Row, Col, Button } from 'react-bootstrap';
import Logo from 'components/common/Logo';
import { FaPrint } from 'react-icons/fa';

const CardTicket = ({ alumnoId, cuotaId }) => {
    const [alumno, setAlumno] = useState({});
    const [cuota, setCuota] = useState({});

    useEffect(() => {
        const ciclo = '2025';
        const fetchAlumno = async () => {
            try {
                const a = await dataAlumno(alumnoId, ciclo);
                setAlumno(a);
            } catch (error) {
                console.error("Error fetching alumno by alumnoId:", error);
            }
        };
        fetchAlumno();
    }, [alumnoId]);

    useEffect(() => {
        const fetchCuota = async () => {
            try {
                const c = await dataCuota(cuotaId);
                setCuota(c);
            } catch (error) {
                console.error("Error fetching cuota by cuotaId:", error);
            }
        };
        fetchCuota();
    }, [cuotaId]);
    const printRef = useRef();

const handleButtonToPrint = () => {
    const printContents = printRef.current.innerHTML;
    alert(printContents);
    const printWindow = window.open('', '', 'height=600,width=800');
    printWindow.document.write('<html><head><title>Comprobante de Cuota Mensual</title>');
    printWindow.document.write('</head><body >');
    printWindow.document.write(printContents);
    printWindow.document.write('</body></html>');
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();
};
return (
    <>
        {alumno && cuota ? (
            <Card className="p-4 shadow-sm border-1" style={{ maxWidth: '600px', margin: '0 auto', fontFamily: 'monospace' }}>
                <Card.Header>
                    <Row>
                        <Col className='text-end'>
                          <Button onClick={ handleButtonToPrint }><FaPrint  /></Button>
                        </Col>
                    </Row>
                </Card.Header>
                <Card.Body ref={printRef} > <div className="text-center mb-3">
                    <Logo width={100} />
                    <h5 className="mt-2 mb-0 fw-bold">Asociación de cultura Saint John's</h5>
                    <small>asociacionsj@gmail.com</small>
                </div>

                <Row className="mb-2">
                    <Col><strong>Fecha:</strong> {cuota.updated_at && cuota.updated_at.split('T')[0]+' - '+cuota.updated_at.split('T')[1].split('Z')[0]}</Col>
                    <Col>
                        <strong>Estado:</strong>
                        <div className={`mt-1 badge fs-1 ${cuota.status === 'pagado' ? 'bg-success' : 'bg-warning'}`}>
                            {cuota.status}
                        </div>
                    </Col>
                </Row>

                <Row className="mb-3">
                    <Col><strong>Nombre:</strong> {alumno.firstName} {alumno.lastName}</Col>
                </Row>

                <hr />

                <Row className="mb-1">
                    <Col><strong>Identificador{': '+ cuota.id}</strong></Col>
                    <Col><strong>Concepto: Cuota Mensual</strong></Col>
                    <Col><strong>Importe: {' '+cuota.monto}</strong></Col>
                </Row>

                <hr />

                <Row className="mb-3">
                    <Col className="text-end"><strong>Total:</strong> ARS {cuota.monto}</Col>
                </Row>

                <Row>
                    <Col>
                        <strong>Medio de pago:</strong> {cuota.metodo}<br />
                    </Col>
                </Row></Card.Body>
               
            </Card>
        ) : (
            <div className="text-center mt-5">Cargando...</div>
        )}
    </>
);

};

CardTicket.propTypes = {
    alumnoId: PropTypes.number.isRequired,
    cuotaId: PropTypes.number.isRequired
};

export default CardTicket;
